type SearchConfirmShortcutEvent = {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
};

export const isSearchConfirmShortcut = (event: SearchConfirmShortcutEvent): boolean =>
  event.key === 'Enter' && (event.metaKey || event.ctrlKey);
